<template>
  <div class="auth-page-wrap">
    <div class="auth-card">
      <h1>登录</h1>
      <div class="form-field">
        <input v-model="email" placeholder="邮箱" />
      </div>
      <div class="form-field pwd-field">
        <input
            :type="showPassword ? 'text' : 'password'"
            v-model="password"
            placeholder="密码"
        />
        <span class="eye-btn" @click="togglePassword">{{ showPassword ? '🙈' : '👁' }}</span>
      </div>
      <div class="form-links">
        <span @click="$router.push('/register')">注册账号</span>
        <span @click="$router.push('/forgetPwd')">忘记密码？</span>
      </div>
      <button class="btn-submit" @click="login">登录</button>
    </div>
  </div>
</template>

<script>
import { login } from '@/utils/http'
import { bus } from '@/utils/bus'

export default {
  data() {
    return {
      email: '',
      password: '',
      showPassword: false
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    async login() {
      const res = await login({ email: this.email, password: this.password })
      if (res.status && res.status === 200) {
        localStorage.setItem('user', JSON.stringify(res.data))
        if (res.data && res.data.uuid) {
          localStorage.setItem('token', res.data.uuid)
        }
        bus.$emit('login-success', res.data)
        const redirect = localStorage.getItem('redirect_after_login')
        if (redirect && redirect !== '/register' && redirect !== '/forgetPwd') {
          localStorage.removeItem('redirect_after_login')
          this.$router.replace(redirect)
        } else {
          this.$router.replace('/')
        }
      } else {
        this.$alert(res.message, '提示', { confirmButtonText: '确定', center: true })
      }
    }
  }
}
</script>
